<template>
  <div>
    <v-tabs v-model="tab" color="realEstate">
      <v-tab class="mw-200" to="admin-recharge">
        {{ $t('recharge.rechargeList') }}
      </v-tab>
      <v-tab
        v-if="!checkUserRole('ROLE_SUPPORT')"
        to="admin-charge"
        class="mw-200"
      >
        {{ $t('charge.title.chargeList') }}
      </v-tab>
    </v-tabs>

    <v-divider class="mb-4 grey lighten-3" />

    <div v-if="tab === 'admin-recharge'">
      <RechargeListAdmin />
    </div>
    <div v-else>
      <AdminChargeList />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import RechargeListAdmin from '@/components/recharge/RechargeListAdmin'
import AdminChargeList from '@/views/charge/components/AdminChargeList'

import { checkUserRole } from '@/util/helpers'

export default {
  name: 'AdminRecharge',

  components: {
    RechargeListAdmin,
    AdminChargeList,
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    ...mapActions(['fetchAdminCharges', 'fetchRechargesAdmin']),
    checkUserRole,
  },

  data() {
    return {
      tab: 'admin-recharge',
    }
  },

  mounted() {
    this.tab = this.$route?.name
  },
}
</script>
